module.exports = __webpack_public_path__ + "img/arrow-down-to-bracket.b6a6f63b.svg";